<form [autocomplete]="uuid">
  <div class="form-label H9 mb-4" *ngIf="config.formLabel">
    {{ config.formLabel }}
  </div>
  <ng-content select="[sub-label-slot]" />
  <div class="form-section" *ngFor="let formGroup of formSections">
    <div class="form-group" *ngIf="shouldDisplayGroup(formGroup)">
      <div
        class="form-section-title H9 semi-bold mb-3"
        *ngIf="formGroup.groupLabel"
      >
        {{ formGroup.groupLabel }}
      </div>
      <div
        [ngClass]="{
          grid: !(filtersForm && uIService.IsPortraitOrientation()),
          'mobile-filters-container': filtersForm && uIService.IsPortraitOrientation(),
        }"
      >
        <ng-container
          *ngIf="
            mobile || (filtersForm && uIService.IsPortraitOrientation());
            else desktopFormField
          "
        >
          <pm-mobile-form-field
            *ngFor="let formField of formGroup.fields"
            [formField]="formField"
            class="pm-form-field"
            [ctrl]="
              toControl(
                this.form.controls[formGroup.groupName].get(formField.name)!
              )
            "
          />
        </ng-container>

        <ng-template #desktopFormField>
          <ng-container *ngFor="let formField of getFormFields(formGroup)">
            <div
              [ngClass]="
                formField?.cols
                  ? 'desktop-form-field-container col col-' + formField?.cols
                  : 'desktop-form-field-container col col-12'
              "
            >
              <ng-container
                *ngTemplateOutlet="
                  getTemplate('before', formField.name);
                  context: { $implicit: formField }
                "
              ></ng-container>
              <pm-form-field
                [formField]="formField"
                class="pm-form-field"
                [ctrl]="
                  toControl(
                    this.form.controls[formGroup.groupName].get(formField.name)!
                  )
                "
              />
              <ng-container
                *ngTemplateOutlet="
                  getTemplate('after', formField.name);
                  context: { $implicit: formField }
                "
              ></ng-container>
            </div>
          </ng-container>
        </ng-template>
      </div>
    </div>
  </div>
  <ng-content ngProjectAs="[extras]"> </ng-content>
  <ng-content ngProjectAs="[submitButton]"> </ng-content>

  <div class="form-errors">
    @for (error of errors(); track error) {
    <div class="mb-3">
      <pm-error-message [message]="error" />
    </div>
    }
  </div>
</form>
